import React from 'react'
import styled, { css, keyframes } from 'styled-components'
import { Box, Flex, getPaletteColor } from 'pcln-design-system'
import PropTypes from 'prop-types'

const getAnimationDelay = (props) => ({
  animationDelay: props.size * 4 + props.index * 64 + 'ms',
})

const bounce = keyframes`
  0% {
    transform: translateY(100%) scale(0.1);
  }
  50% {
    transform: translateY(-100%) scale(1);
  }
  100% {
    transform: translateY(100%) scale(0.1);
  }
`

const bounceAnimation = css`
  ${bounce} 2s infinite ease-in-out both;
`

const LoaderFrame = styled(Flex)`
  align-items: center;
  justify-content: space-around;
  margin: 10px auto;
  width: 40px;
  height: 24px;
`

const Ball = styled(Box)`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border-radius: 100%;
  display: inline-block;
  animation: ${bounceAnimation};
  ${getAnimationDelay};
  background-color: ${getPaletteColor('primary.base')};
`

const LoaderDots = ({ color, size }) => {
  const paddingSize = `${size}px`
  return (
    <LoaderFrame data-testid='loader-dots'>
      <Box pr={paddingSize}>
        <Ball index={0} bg={color} size={size} />
      </Box>
      <Box pr={paddingSize}>
        <Ball index={1} bg={color} size={size} />
      </Box>
      <Box>
        <Ball index={2} bg={color} size={size} />
      </Box>
    </LoaderFrame>
  )
}

LoaderDots.defaultProps = {
  size: 8,
}

LoaderDots.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
}

export default LoaderDots
